import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				background: theme.palette.common.white,
				padding: "5px 10px",
				marginBottom: 10,
				borderRadius: 6,
				display: "flex",
				alignItems: "center",
				boxShadow: "0px 3px 29px rgba(114, 136, 128, 0.15)",
				justifyContent: "space-between"
			},
			title: {
				display: "flex",
				alignItems: "center",
				fontSize: 14,
				color: theme.palette.primary.contrastText
			},
			point: {
				fontSize: 14,
				color: theme.palette.error.light,
				fontWeight: 500
			}
		}),
	{
		name: "PointLoyalty",
		index: 1
	}
);

export default useStyles;
